export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthToken = (state) => state.auth.token;
export const selectCurrentUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => !!state.auth.token;
export const selectVendorRegSelfLoading = (state) => state.auth.loading;
export const selectVendorRegSelfError = (state) => state.auth.error;

export const selectAllClients = (state) => state.auth.allClients;
export const selectAllClientsLoading = (state) => state.auth.loading;
